import PlaneAction from "./PlaneAction.js";
import {descend} from "../planeSlice.js";

export default class Descend extends PlaneAction {
    constructor(planeId, targetAltitude) {
        super(planeId);
        this.targetAltitude = targetAltitude;
    }

    execute() {
        this.log(`Descending to ${this.targetAltitude}ft`);
        this.dispatch(descend({altitude: this.targetAltitude}));
    }

    isComplete = () => true;
}

